export const CLOSE_ICON = {
    color: "#F0F0F5",
    fill: "#616469",
    size: 28,
};

export const TOING_POPUP_CONFIG = {
    imageId: "portal/static-assets/hcms/PopUp_newmascot.png",
    height: "300px",
    width: "300px",
    alt: "toing-popup-image",
    ctaText: "Yay!",
};

export const LABELS = {
    CLOSE_CLICK: "close-click",
    BUTTON_CLICK: "button-click",
};
